<script setup>
import { onMounted } from 'vue'

import { loadScript } from '../../../utils/script-loader'

const props = defineProps({
  html: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['scriptLoaded'])

const getScriptSrcFromEmbedHTML = html => {
  const src = html.match(/script async src\s*=\s*["'](.+?)["']/)
  return src ? src[1].trim() : null
}

onMounted(async () => {
  const src = getScriptSrcFromEmbedHTML(props.html)

  if (!src) {
    return
  }

  try {
    await loadScript(src)
    emit('scriptLoaded', { success: true, src })
  } catch (error) {
    emit('scriptLoaded', { success: false, src, error })
  }
})
</script>

<template>
  <div v-html="html" />
</template>
